<!--*
*   Copyright (C) Cylergie - All Rights Reserved
* Proprietary and confidential
* Subject to French law on copyright
* Unauthorized copying of this file, via any medium is strictly prohibited: https://crigen.myengie.com/copyright
* Any request for authorization of use should be addressed by email to“mvalo.bvt@engie.com” with the subject “Copyright Statement in Source Code”
* Written in 2024 
* -->

<template>
  <div id="app">
    <router-view />
    <link href="https://fonts.googleapis.com/icon?family=Material+Icons" rel="stylesheet" />
  </div>
</template>

<script>
/* eslint-disable */
export default {
  created() {
    console.log('--- IN APP ---');
  },
  watch: {
    $route(to, from) {
      console.log('Route changed from ' + from.path + ' to ' + to.path);
    },
  },
};
</script>

<style>
html {
  overflow-y: hidden;
}

* {
  transition: 0.4s;
}

.sortable-chosen * {
  cursor: grabbing !important;
}

.v-toolbar__content {
  padding: 0px !important;
}

.view-setup {
  height: calc(100vh - 56px);
  background-color: #e6e6e6;
}

.view-previsions {
  height: calc(100vh - 56px);
  width: 100%;
  overflow: hidden;
}

.view-site,
.view-boiler {
  display: flex;
  flex-direction: column;
  height: calc(100vh - 97px);
  width: 100%;
  justify-content: center;
  align-items: center;
}

.view-boiler .v-slider {
  margin-bottom: 0.5em;
}

.view-boiler .v-input__prepend-outer input,
.view-boiler .v-input__append-outer input {
  padding-top: 0px;
}

.view-boiler fieldset fieldset {
  height: 40px;
}

.main-container {
  display: flex;
  flex-direction: column;
  width: 100%;
  height: calc(100vh - 153px);
  align-items: center;
  justify-content: center;
  background-color: white;
}

.button-container {
  display: flex;
  width: 100%;
  height: 56px;
  padding-right: 1%;
  padding-left: 1%;
  justify-content: space-between;
  align-items: center;
  bottom: 0vh;
  border-top: 3px solid lightgray;
}

.button-container button {
  display: block;
  padding-right: 15px;
  padding-left: 15px;
  height: 40px;
  width: 140px;
  text-align: center;
  border-radius: 3px;
  background: #00aaff;
  color: white;
  text-decoration: none;
  font-weight: 500;
  letter-spacing: 1px;
  box-shadow: 2px 2px 2px rgba(0, 0, 0, 0.1);
  border: none;
  margin-right: 1%;
}

/* Chrome, Safari, Edge, Opera */
input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

/* Firefox */
input[type='number'] {
  -moz-appearance: textfield;
}

.theme--light.v-toolbar.v-sheet {
  background-color: transparent;
}
</style>
